module.exports = __webpack_public_path__ + "img/RightShadow.332e5b12.png";